import { Validator } from "../Validator"

export default class NameSuggestionIndexValidator extends Validator {
    constructor() {
        super(
            "nsi",
            "Gives a list of possible suggestions for a brand or operator tag. Note: this is detected automatically; there is no need to explicitly set this"
        )
    }

    validateArguments(args: string): string | undefined {
        return "No arguments needed"
    }
}
